module.exports = __webpack_public_path__ + "img/luz-e-sombra-aberto.b9f4ddb1.jpg";